<template>
     <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
        <div class="row">
           <div class="col l4 offset-l2 input-field">
              <inncosys-date-picker  :options="{}" label="Fecha Inicio" v-model="fechaInicio"></inncosys-date-picker>
            </div>
            <div class="col l4 input-field">
              <inncosys-date-picker  :options="{}" label="Fecha Fin" v-model="fechaFin"></inncosys-date-picker>
            </div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                <h5>Ocupación PROSIC</h5>
                <div >
                  <div v-if="loadingResults" class="progress">
                      <div class="indeterminate"></div>
                  </div>
                    <datatable title="Ocupación en tiempo" :columns="columns" :rows="rows" @row-click="openDetailsModal"></datatable>

                </div>
            </div>
        </div>
         <div id="modal1" class="modal" ref="modalDetail">
          <div class="modal-content">
            <h4>Detalle Ocupación</h4>
            <datatable title="Ocupación en tiempo detalle" :columns="columnsDetails" :rows="series" ></datatable>
          </div>
          <div class="modal-footer">
            <a href="#!" class="modal-close waves-effect waves-green btn-flat">Agree</a>
          </div>
        </div>
    </main>
</template>

<script>
import Breadcrumbs from '../../components/commun/Breadcrumbs.vue';
import DatePicker from '../../components/commun/forms/DatePicker.vue';
import DataTable from 'vue-materialize-datatable';
import axios from 'axios';
import {ocupacionEnTiempo} from '../../controllers/reportes-directivos/ocupacion-tiempo';

export default {
  mounted() {
    this.ocupacionEnTiempoInstance = new ocupacionEnTiempo();
    this.detailModal = M.Modal.init(this.$refs.modalDetail);
  },
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysDatePicker: DatePicker,
    datatable: DataTable,
  },
  data() {
    return {
      Highcharts: null,
      ocupacionEnTiempoInstance: null,
      pathHistory: [
        { name: 'Inicio', route: '/' },
        {
          name: 'Reportes Directivos',
          route: '/reportes-directivos/ocupacion',
        },
        {
          name: 'Ocupacion',
          route: '/reportes-directivos/ocupacion',
        },
      ],
      selectedStore: '',
      loadingResults: false,
      fechaInicio: null,
      fechaFin: null,
      columns: [
        {
          label: 'Familia', // Column name
          field: 'familia', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },

        {
          label: 'Marca', // Column name
          field: 'marca', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Modelo', // Column name
          field: 'modelo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Ocupacion', // Column name
          field: 'porcentajeOcupacion', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      columnsDetails: [
        {
          label: 'Familia', // Column name
          field: 'familia', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },

        {
          label: 'Marca', // Column name
          field: 'marca', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Modelo', // Column name
          field: 'modelo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Seire', // Column name
          field: 'serie', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Tiempo Ocupado', // Column name
          field: 'ocupacionTiempo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Tiempo Inventario', // Column name
          field: 'inventarioTiempo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Ocupacion', // Column name
          field: 'porcentajeOcupacion', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      series: [],
      rows: [
        {
          modelo: 'Modelo',
          marca: 'JLG',
          familia: 'Plataformas de Tijera',
          porcentajeOcupacion: 50.2,
        },
      ],
      detailModal: null,
    };
  },
  methods: {
    openDetailsModal(data) {
      this.series = data.series;
      this.detailModal.open();
      console.log(data.series);
    },
    getOcupacionEnTiempo() {
      this.loadingResults = true;
      const vueInstance = this;
      this.ocupacionEnTiempoInstance
        .getReporteOcupacion(axios, this.fechaInicio, this.fechaFin)
        .then((reporteUbicacion) => {
          vueInstance.loadingResults = false;
          const hashMapOcupacionPorModelo = {};
          reporteUbicacion.forEach((result) => {
            if (!hashMapOcupacionPorModelo[result.modelo]) {
              hashMapOcupacionPorModelo[result.modelo] = {
                modelo: result.modelo,
                marca: result.marca,
                familia: result.familia,
                items: 0,
                porcentajeOcupacionSum: 0,
                porcentajeOcupacion: 0,
                series: [],
              };
            }
            hashMapOcupacionPorModelo[result.modelo].series.push(result);
            hashMapOcupacionPorModelo[
              result.modelo
            ].porcentajeOcupacionSum += parseFloat(result.porcentajeOcupacion);
            hashMapOcupacionPorModelo[result.modelo].items++;
            hashMapOcupacionPorModelo[result.modelo].porcentajeOcupacion =
              hashMapOcupacionPorModelo[result.modelo].porcentajeOcupacionSum /
              hashMapOcupacionPorModelo[result.modelo].items;
          });
          vueInstance.rows = Object.values(hashMapOcupacionPorModelo);
        });
    },
  },
  watch: {
    fechaInicio(value) {
      if (this.fechaInicio != null && this.fechaFin != null) { this.getOcupacionEnTiempo(); }
    },
    fechaFin(value) {
      if (this.fechaInicio != null && this.fechaFin != null) { this.getOcupacionEnTiempo(); }
    },
  },
};
</script>
